import {
    APP_NOTIFICATION_PREFERENCE,
    DATE_FORMAT_PREFERENCE,
    EMAIL_NOTIFICATION_PREFERENCE,
    START_PAGE_PREFERENCE,
    TIME_FORMAT_PREFERENCE,
} from '@constants/userPreferences.ts';
import type { UserInfoPreferences, UserInfoResponse } from '@routes/___shared___/user.api.ts';
import type { UserPreferencesSettings } from '@types';

import { USER_PREFERENCES_DEFAULTS } from '../profile-bar/___shared___/constants.ts';

export const getUserPreferencesOrDefaults = (userInfo: UserInfoResponse | null): UserPreferencesSettings => {
    const preferences: UserInfoPreferences = USER_PREFERENCES_DEFAULTS;

    if (userInfo && userInfo.preferences) {
        const { landingPage, dateFormat, timeFormat, notificationsApp, notificationsEmail } = userInfo.preferences;
        preferences.timeFormat = timeFormat || preferences.timeFormat;
        preferences.dateFormat = dateFormat || preferences.dateFormat;
        preferences.landingPage = landingPage || preferences.landingPage;
        if (notificationsEmail !== undefined) preferences.notificationsEmail = notificationsEmail;
        if (notificationsApp !== undefined) preferences.notificationsApp = notificationsApp;
    }

    return {
        [START_PAGE_PREFERENCE]: preferences.landingPage,
        [DATE_FORMAT_PREFERENCE]: preferences.dateFormat,
        [TIME_FORMAT_PREFERENCE]: preferences.timeFormat,
        [APP_NOTIFICATION_PREFERENCE]: preferences.notificationsApp,
        [EMAIL_NOTIFICATION_PREFERENCE]: preferences.notificationsEmail,
    };
};
